import { CSSProperties, useState } from "react";

import { CustomButton } from "@/common/components";
import CustomModal from "@/common/components/Modal";

import { EHierarchyModelViewType, HierarchyModelBase } from "../types";

export const ArchiveAtForm = ({
  type,
  selected,
  handleDelete,
  handleRestore,
  sx,
}: {
  type: EHierarchyModelViewType;
  selected: HierarchyModelBase;
  handleDelete?: (
    event: React.MouseEvent,
    setArchiveConfirmModalOpen: (isOpen: boolean) => void,
    archiveValue: boolean,
  ) => void;
  handleRestore?: (
    event: React.MouseEvent,
    setArchiveConfirmModalOpen: (isOpen: boolean) => void,
    archiveValue: boolean,
  ) => void;
  sx: CSSProperties;
}) => {
  const typeLc = type.toLowerCase();
  const [archiveConfirmModalOpen, setArchiveConfirmModalOpen] = useState(false);
  const isArchived = !(selected.archivedAt === null);

  const onSubmit = (event: React.MouseEvent) => {
    if (isArchived) {
      handleRestore?.(event, setArchiveConfirmModalOpen, isArchived);
    } else {
      handleDelete?.(event, setArchiveConfirmModalOpen, isArchived);
    }
  };

  return (
    <>
      {((!isArchived && handleDelete) || (isArchived && handleRestore)) && (
        <>
          <CustomButton
            className={`archive-${typeLc}}`}
            variant="outlined"
            color="error"
            onClick={() => setArchiveConfirmModalOpen(true)}
            trackingLabel={`archive-${typeLc}}`}
            sx={sx}
          >
            {isArchived ? "Restore" : "Archive"} {type}
          </CustomButton>

          <CustomModal
            isOpen={archiveConfirmModalOpen}
            modalHeaderText={
              <>
                Are you sure you want to {isArchived ? "restore" : "archive"} <b>{selected.name}</b>{" "}
                {typeLc}?
              </>
            }
            onSubmit={onSubmit}
            primaryBtnText={`${isArchived ? "Restore" : "Archive"} ${type}`}
            withBlurBackground
            dangerousActionPhrase={selected.name.trim()}
            onSecondaryBtnClick={() => setArchiveConfirmModalOpen(false)}
          />
        </>
      )}
    </>
  );
};
